// @flow

import Service from '../service';
import type { EdeEnrollmentModelType } from '../../types/ede/enrollment';

export default class EnrollmentService extends Service {
  postEnrollment(
    ifp_app_id: string,
    checkPriceThreshold: boolean,
  ): Promise<EdeEnrollmentModelType> {
    return this.api.post(`${this.baseUrl}/ede/enrollment/${ifp_app_id}`, { checkPriceThreshold })
      .then(res => res.data);
  }

  putEnrollment(ifp_app_id: string): Promise<EdeEnrollmentModelType> {
    return this.api.put(`${this.baseUrl}/ede/enrollment-status/${ifp_app_id}`)
      .then(res => res.data);
  }
}
